var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 614,
    viewBox: "0 0 388 614",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_d_3310_34108)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29205 -120.6C63.5563 -114.632 123.098 -141.625 181.77 -126.597C250.846 -108.905 341.111 -93.8575 367.245 -27.3824C394.538 42.0401 316.606 109.731 303.56 183.193C293.399 240.413 328.406 304.187 299.425 354.529C270.443 404.872 199.663 408.725 153.484 443.887C98.8043 485.523 69.4693 561.631 3.29205 580.02C-65.5487 599.149 -152.756 592.984 -204.153 543.263C-257.042 492.1 -220.056 397.362 -253.396 331.707C-284.084 271.275 -386.91 251 -387 183.193C-387.09 115.418 -286.333 93.864 -253.791 34.4505C-220.152 -26.9639 -256.682 -127.961 -196.784 -164.087C-137.301 -199.962 -65.7969 -127.442 3.29205 -120.6Z",
    fill: "#EFF6FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter1_d_3310_34108)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-22.3123 -98.5765C33.9984 -93.0083 89.6341 -118.192 144.457 -104.172C209.001 -87.6652 293.345 -73.6258 317.764 -11.6059C343.266 53.1639 270.447 116.318 258.258 184.857C248.763 238.242 281.473 297.742 254.393 344.71C227.313 391.679 161.176 395.274 118.027 428.08C66.9341 466.925 39.5235 537.933 -22.3123 555.089C-86.6368 572.935 -168.123 567.184 -216.149 520.796C-265.568 473.061 -231.008 384.672 -262.161 323.418C-290.836 267.036 -386.916 248.12 -387 184.857C-387.084 121.624 -292.937 101.515 -262.529 46.083C-231.098 -11.2155 -265.232 -105.444 -209.263 -139.148C-153.682 -172.62 -86.8688 -104.96 -22.3123 -98.5765Z",
    fill: "#EFF6FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter2_d_3310_34108)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-48.6085 -76.5525C3.64191 -71.3844 55.2659 -94.7589 106.136 -81.7458C166.026 -66.4251 244.288 -53.3942 266.947 4.17059C290.61 64.2878 223.041 122.906 211.731 186.521C202.921 236.071 233.272 291.297 208.145 334.891C183.017 378.486 121.649 381.822 81.6115 412.272C34.2027 448.327 8.76862 514.234 -48.6085 530.157C-108.295 546.722 -183.905 541.384 -228.468 498.328C-274.324 454.023 -242.256 371.983 -271.162 315.128C-297.77 262.796 -386.922 245.239 -387 186.521C-387.078 127.83 -299.72 109.165 -271.505 57.7155C-242.339 4.53299 -274.012 -82.9268 -222.079 -114.21C-170.505 -145.277 -108.51 -82.4775 -48.6085 -76.5525Z",
    fill: "#EFF6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3310_34108",
    x: -402,
    y: -181,
    width: 790,
    height: 794.043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3310_34108"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.254902 0 0 0 0 0.333333 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3310_34108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3310_34108",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3310_34108",
    x: -402,
    y: -155.397,
    width: 740.142,
    height: 742.837,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3310_34108"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.254902 0 0 0 0 0.333333 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3310_34108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3310_34108",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3310_34108",
    x: -402,
    y: -129.795,
    width: 688.936,
    height: 691.631,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3310_34108"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.254902 0 0 0 0 0.333333 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3310_34108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3310_34108",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLeft);
export default __webpack_public_path__ + "static/media/BGLeft.c28fb0690ed1dc677f6176d2dbbd46b5.svg";
export { ForwardRef as ReactComponent };